import React, { useEffect, useState, useContext } from "react";
import {
  List,
  Input,
  Button,
  Row,
  Col,
  message,
  Radio,
  Select,
  Tag,
  Space,
  Form,
  notification,
  Typography,
  Divider,
  Spin,
  Empty,
} from "antd";
import Axios from "axios";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import {
  HomeTwoTone,
  SettingTwoTone,
  SmileOutlined,
  SyncOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
  SmileTwoTone,
} from "@ant-design/icons";
import {
  environmentVariable,
  environment,
  apiRoutes,
} from "../../auth/apiRoute";
import AdminLayout from "../../layout/adminLayout";
import { UserContext } from "../../auth/userContext";
export default function ViewNomination(props) {
  const navigate = useNavigate();
  const { Title, Paragraph, Text } = Typography;
  const { state } = useLocation();
  const [form] = Form.useForm();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState();
  const [currentNomination, setCurrentNomination] = useState({});
  const [nominationNavigation, setNominationNavigation] = useState({});
  const [keywordsToAvoid, setKewWords] = useState([]);

  const [exceptions, setException] = useState(["of", "the"]);
  let { nominationId } = useParams();

  const [hotels, setHotels] = useState([]);
  const [nominationsData, setNominations] = useState([]);
  const categories = [
    "Full-Time Hourly With Guest Contact",
    "Full-Time Hourly Without Guest Contact",
    "Full-Time Room Attendant",
    "Managerial Below General Manager",
  ];
  const questions = [
    "1. Describe the employee’s overall job performance and dedication to his/her profession and to your Hotel. Please be specific and cite at least one example.",
    "2.  Describe the interaction of the employee with his/her coworkers and/or with guests. Please cite specific examples of the employee’s positive impact on the guest experience at your hotel. ",

    "3. Please list any awards or recognition that the employee has received from the Hotel, management, guests, award organizations and/or peers.",
    "4. Please list any other reasons for nominating this employee for the Big Apple Stars Awards.",
  ];
  const userContext = useContext(UserContext);
  useEffect(() => {
    // getUser();
    // getNominations();
    // console.log(userContext);
    getNominationById(nominationId);
    if (!state || !state.nominations) {
      getNominationNavigation(nominationId);
    }
  }, [nominationId]);
  useEffect(() => {
    updateKeyWordsToAvoid(currentNomination);
  }, [currentNomination]);

  const getNominations = async () => {
    console.log("get nominations");
    try {
      const response = await Axios.post(apiRoutes[environment].nominations);

      if (response.status == 200) {
        var nominations = response.data;
        nominations = nominations
          .map((item) => {
            return { ...item, ...{ key: item._id } };
          })
          .filter((item) => item.term == new Date().getFullYear());
        setNominations(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };

  const getNominationById = async (nominationId) => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].getnomination, {
        nominationId: nominationId,
      });
      setLoading(false);
      console.log(response.data);
      if (response.status == 200) {
        setCurrentNomination(response.data);

        setHotels([response.data.hotel]);

        setSelectedHotel(response.data.hotel);
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }

    setLoading(false);
  };
  const getNominationNavigation = async (nominationId) => {
    try {
      const response = await Axios.post(
        apiRoutes[environment].nominationsNavigation,
        {
          nominationId,
          ...(state && state.nominationNavigation
            ? state.nominationNavigation
            : {}),
        },
      );

      if (response.status == 200) {
        setNominationNavigation(response.data);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      }
    }
  };
  const Highlighted = ({ text = "", highlight = "" }) => {
    if (!highlight.trim()) {
      return <span>{text}</span>;
    }
    const regex = new RegExp(`(${highlight})`, "gi");
    const parts = text.split(regex);
    return (
      <span>
        {parts
          .filter((part) => part)
          .map((part, i) =>
            regex.test(part) ? (
              <mark key={i}>{part}</mark>
            ) : (
              <span key={i}>{part}</span>
            )
          )}
      </span>
    );
  };
  const questionsAndAnswers = () => {
    var finalJudges = {
      "asteel@javitscenter.com": "Alan Steel",
      "ng67@nyu.edu": "Nicolas Graf",
      "sfh1@nyu.edu": "Sean Hennessey",
      "parks2@stjohns.edu": "Seunghyun Park",
    };
    if (!currentNomination || !currentNomination.hotel) {
      return;
    }

    return questions.map((question, index) => {
      return (
        <Paragraph key={index + "q"}>
          <Text>{question}</Text>
          <Paragraph className="admin-view-nomination-answer">
            {currentNomination["q" + (index + 1)] &&
            currentNomination["q" + (index + 1)].answer ? (
              <p className="display-linebreak">
                {" "}
                <Highlighted
                  text={currentNomination["q" + (index + 1)].answer}
                  highlight={keywordsToAvoid.join("|")}
                />
              </p>
            ) : (
              <Empty description={"No response"} />
            )}
          </Paragraph>

          {currentNomination["q" + (index + 1)] && (
            <Text strong>
              Score : <Tag>{currentNomination["q" + (index + 1)].score}</Tag>
            </Text>
          )}
          <Paragraph>
            {currentNomination["q" + (index + 1)]["finalScores"] && (
              <Text strong>Final Scores:</Text>
            )}
            {currentNomination["q" + (index + 1)]["finalScores"] &&
              Object.keys(
                currentNomination["q" + (index + 1)]["finalScores"]
              ).map((key) => {
                return (
                  <Text key={currentNomination._id + index + key}>
                    <Text>
                      {finalJudges[key]} :{" "}
                      <Tag strong>
                        {
                          currentNomination["q" + (index + 1)]["finalScores"][
                            key
                          ]
                        }
                      </Tag>
                    </Text>
                  </Text>
                );
              })}
          </Paragraph>
        </Paragraph>
      );
    });
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: "Your nomination has been successfully updated! ",
      placement: "top",
    });
  };

  const hashNomination = (keyword) => {
    var newNomination = Object.assign({}, currentNomination);
    const questions = ["q1", "q2", "q3", "q4"];
    for (const question of questions) {
      if (!newNomination[question].answer) {
        continue;
      }
      console.log(newNomination[question].answer, keyword);

      var regEx = new RegExp(keyword, "ig");
      var replaceMask = "xxx";
      newNomination[question].answer = newNomination[question].answer.replace(
        regEx,
        replaceMask
      );
    }
    console.log(newNomination);
    try {
      setLoading(true);
      const resp = Axios.post(
        apiRoutes[environment].hashNomination,
        newNomination
      );
      console.log(resp.data);
    } catch (error) {
      console.log(error.data);
    }

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const updateKeyWordsToAvoid = (record) => {
    if (record && record.hotel) {
      var hotelKeywords = record.hotel.name.split(" ");

      hotelKeywords = hotelKeywords.filter((item) => {
        return exceptions.every((exceptItem) => {
          return exceptItem.toLowerCase() != item.toLowerCase();
        });
      });
      var firstNameVariants = record.firstName
        .split(" ")
        .filter((item) => item.length > 0);
      var lastNameVariants = record.lastName
        .split(" ")
        .filter((item) => item.length > 0);

      var keywords = [
        record.firstName + " " + record.lastName,
        ...firstNameVariants,
        ...lastNameVariants,
        record.hotel.name,
        record.firstName.replace(" ", ""),
        record.lastName.replace(" ", ""),
        ...hotelKeywords,
      ];

      setKewWords(keywords);
    }
  };
  const keyWordsOccurance = (record) => {
    if (keywordsToAvoid) {
      const questions = ["q1", "q2", "q3", "q4"];
      var occurenceByKeyword = {};

      for (const key of keywordsToAvoid) {
        occurenceByKeyword[key] = 0;
      }
      for (const question of questions) {
        if (!record[question] || !record[question].answer) {
          continue;
        }

        for (const keyword of keywordsToAvoid) {
          const regex = new RegExp(`(${keyword})`, "gi");

          occurenceByKeyword[keyword] =
            (record[question].answer.match(regex) || []).length +
            occurenceByKeyword[keyword];

          // if (answer.toLowerCase().includes(keyword.toLowerCase())) {
          //   occurenceByKeyword[keyword] += 1;
          // }
        }
        // for (const answer of record[question].answer) {
        //   console.log(answer);
        //   for (const keyword of keywordsToAvoid) {
        //     const regex = new RegExp(`(${keyword})`, "gi");

        //     occurenceByKeyword[keyword] = (answer.match(regex) || []).length;

        //     // if (answer.toLowerCase().includes(keyword.toLowerCase())) {
        //     //   occurenceByKeyword[keyword] += 1;
        //     // }
        //   }
        // }
      }

      var occurenceByKeywordKeys = Object.keys(occurenceByKeyword);

      occurenceByKeywordKeys = occurenceByKeywordKeys.filter(
        (item) => occurenceByKeyword[item] != 0
      );

      return (
        <List
          style={{ width: "300px" }}
          bordered
          itemLayout="horizontal"
          dataSource={occurenceByKeywordKeys}
          renderItem={(item) => (
            <List.Item
              actions={[
                <a
                  onClick={() => {
                    hashNomination(item);
                  }}
                >
                  Hash
                </a>,
                <a
                  onClick={() => {
                    setException([...exceptions, item]);
                  }}
                >
                  Ignore
                </a>,
              ]}
            >
              <Text key={item}>
                {item} : {occurenceByKeyword[item]}
              </Text>
            </List.Item>
          )}
        />
      );
    }
  };

  const AddKeyWord = () => {
    const onFinish = (values) => {
      setKewWords([...keywordsToAvoid, values.keyword]);
    };
    return (
      <Form form={form} layout="inline" onFinish={onFinish}>
        <Form.Item name="keyword">
          <Input placeholder="John" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Add
          </Button>
        </Form.Item>
      </Form>
    );
  };
  const footer = () => {
    if (state && state.nominations) {
      const nominations = state.nominations;
      const total = nominations.length;
      const index = nominations.findIndex((item) => item == nominationId);

      return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button disabled={index <= 0}>
            <Link
              to={`/admin/nominations/${nominations[index - 1]}`}
              state={{ ...state, nominations }}
            >
              Previous
            </Link>
          </Button>
          <div>
            <Text>
              {index > -1 ? index + 1 : "-"} / {total}
            </Text>
          </div>
          <Button disabled={index == -1 || index == total - 1}>
            <Link
              to={`/admin/nominations/${nominations[index + 1]}`}
              state={{ ...state, nominations }}
            >
              Next
            </Link>
          </Button>
        </div>
      );
    }

    const navigationState = state && state.nominationNavigation
      ? { nominationNavigation: state.nominationNavigation }
      : {};

    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button disabled={!nominationNavigation.previousId}>
          <Link
            to={`/admin/nominations/${nominationNavigation.previousId}`}
            state={navigationState}
          >
            Previous
          </Link>
        </Button>
        <div>
          <Text>
            {nominationNavigation.index > -1
              ? nominationNavigation.index + 1
              : "-"}{" "}
            / {nominationNavigation.total || 0}
          </Text>
        </div>
        <Button disabled={!nominationNavigation.nextId}>
          <Link
            to={`/admin/nominations/${nominationNavigation.nextId}`}
            state={navigationState}
          >
            Next
          </Link>
        </Button>
      </div>
    );
  };
  return (
    <Spin spinning={loading}>
      <div style={{ width: "80%" }}>
        <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={() => navigate(-1)}>
              <ArrowLeftOutlined />
              go back
            </Button>

            <Button>
              <Link
                to={`/admin/nomination/${nominationId}/edit`}
                state={
                  state
                    ? {
                        nominations: state.nominations,
                        nominationNavigation: state.nominationNavigation,
                      }
                    : {}
                }
              >
                Edit
              </Link>
            </Button>
          </div>
        </>
        <Title level={2}>
          {currentNomination.firstName} {currentNomination.lastName}
        </Title>
        <Divider orientation="left"></Divider>
        <Space direction="vertical" size="middle">
          <Title level={4}>Mentions</Title>
          {keyWordsOccurance(currentNomination)}
          <AddKeyWord />
        </Space>

        <Divider orientation="left"></Divider>
        <Paragraph>
          <ul>
            <HomeTwoTone />
            From:{" "}
            <Text strong>
              {" "}
              {currentNomination.hotel ? currentNomination.hotel.name : ""}{" "}
            </Text>
            <SettingTwoTone /> For:{" "}
            <Text strong>
              {currentNomination.category ? currentNomination.category : ""}{" "}
            </Text>
            <SmileTwoTone /> By:{" "}
            <Text strong>
              {currentNomination.user && currentNomination.user.firstName
                ? currentNomination.user.firstName
                : ""}{" "}
              {currentNomination.user && currentNomination.user.lastName
                ? currentNomination.user.lastName
                : ""}
            </Text>
          </ul>
        </Paragraph>
        {questionsAndAnswers()}
      </div>

      {footer()}
    </Spin>
  );
}
